export const IS_SSR = typeof window === 'undefined';

export const DESKTOP_PRIMARY_CONTAINER_WIDTH = 1060;
export const DESKTOP_SECONDARY_CONTAINER_WIDTH = 884;
export const PC_SEARCH_HOME_SCROLL_PADDING_TOP = 32;
export const SEARCH_HOME_TITLE_HEIGHT = 52;
export const CATEGORY_TAB_HEIGHT = 50;
export const CTA_BAR_HEIGHT = 72;
export const HEADER_Z_INDEX = 99;

export const MRT_MAIN_HEADER_ID = 'mrt-main-header';

export const MRT_FOOTER_ID = 'footerCover';

/**
 * 버전 관리 방식:
 * - 각 스토리지 아이템은 { version: 'v1', data: 실제데이터 } 형태로 저장
 * - 버전이 변경되면 이전 버전의 데이터는 자동으로 삭제되고 초기값으로 리셋
 *
 * ex:
 * railEuropeSearch: (journeyType: string) => ({
 *   key: `rail-europe-search-condition-${journeyType}`,
 *   defaultValue: {},
 *   version: 'v2',  // 버전 변경 시 이 값만 업데이트
 * }),
 */
export const STORAGE_ITEMS = {
  railEuropeSearch: (journeyType: string) => ({
    key: `rail-europe-search-condition-${journeyType}`,
    defaultValue: {},
    version: 'v2',
  }),
} as const;

export const CLOUD_FRONT_URL = 'https://dffoxz5he03rp.cloudfront.net';

export const DEPARTURE_TIME_OPTION_LIST_HEIGHT = 222;
export const DEPARTURE_TIME_OPTION_LIST_WIDTH = 120;
export const DEPARTURE_TIME_OPTION_CONTAINER_PADDING = 12;
